import React from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import { useEffect } from "react";
const PTAMember = () => {
  useEffect(() => {
    // Set the page title
    document.title = "PTA Member - Presentation Convent School Delhi";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> School </li>
          <li>PTA Member</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>PTA Member</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <h5> PRESENTATION DELHI </h5>
              <ul className="list">
                <li>Sr. Elsie Thomas</li>
                <li>Sr. Nisha Thomas </li>
                <li>Sr. Regi Joseph </li>
                <li>Sr. Tresa Tauro </li>
                <li>Sr. Hema Barretto </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h5> REPRESENTATIVES OF TEACHERS </h5>
              <ul className="list">
                <li>Ms. Chaturya K </li>
                <li>Mrs. Shweta Stephen </li>
                <li>Mrs. Jyoti Sachdev</li>
                <li>Mrs. Sherin George</li>
                <li>Mrs. Annu Mehta</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h5> REPRESENTATIVES OF PARENTS </h5>
              <ul className="list">
                <li>Mr. Arun Sharma </li>
                <li>Mr. Alok Kumar Sinha </li>
                <li>Mrs. Priyanka Malik </li>
                <li>Mr. Amit Kumar Singh </li>
                <li>Mr. Ashish Ranjan </li>
                <li>Mr. Sijo Chacko </li>
                <li>Mrs. Ekta Jain </li>
                {/* <li>Mr. Amit Kumar Singh</li>
                <li>Mr. Ashish Ranjan</li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PTAMember;
